import { Box } from '@mui/material';
import SearchBar from 'src/components/SearchBar/SearchBar';
import SearchDrawer from 'src/components/SearchDrawer/SearchDrawer';
import { useEffect, useState } from 'react';
import { useSearch } from 'src/context/SearchProvider/useSearch';
import { Breakpoint, Grid } from '@mui/material';
import { FlexContainer } from 'src/components/styles';

interface SearchDrawerButtonProps {
  columns?: { [key in Breakpoint]?: number };
}

const columnBreakpoints = {
  xs: 10,
  sm: 11,
  md: 2.6,
  xl: 2.6,
};

const SearchDrawerButton = ({
  columns = columnBreakpoints,
}: SearchDrawerButtonProps) => {
  const { clearSearch, searchTerm } = useSearch();
  const [searchOpen, setSearchOpen] = useState(false);

  const handleOpenSearch = () => {
    setSearchOpen(true);
  };

  const handleCloseSearch = () => {
    clearSearch();
    setSearchOpen(false);
  };

  useEffect(() => {
    if (!searchOpen && searchTerm) {
      setSearchOpen(true);
    }
  }, [searchTerm, searchOpen]);

  return (
    <Grid item {...columns}>
      <FlexContainer
        width="100%"
        pr={{ md: 1 }}
        pl={{ xs: 1, md: 0 }}
        justifyContent="space-between"
        alignItems="center"
      >
        <Box
          width="100%"
          onClick={handleOpenSearch}
          sx={{
            cursor: 'pointer',
            '& .MuiInputBase-root': {
              cursor: 'pointer',
            },
            '& .MuiInputBase-input': {
              cursor: 'pointer',
            },
          }}
        >
          <Box sx={{ pointerEvents: 'none' }}>
            <SearchBar />
          </Box>
        </Box>
        <SearchDrawer open={searchOpen} onClose={handleCloseSearch} />
      </FlexContainer>
    </Grid>
  );
};

export default SearchDrawerButton;
